import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

import Alert from '@mui/material/Alert';
import { Button, Divider,TextField, Grid, Typography, Box,CircularProgress } from "@mui/material"

import {getMlmorderStruct, setData} from './MlmorderStruct'
import { updateTextValue, handleSubmit,updateValue,updateSelectedValue} from '../../core/js/FormUtils'
import {createAPI, updateAPI, getAPI, updateEditableAPI} from './MlmorderAPI';
import {CoreContext} from "../../core/context/CoreContext";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {validMobileNumberEntry, validNameEntry, validEmailEntry} from '../../core/js/FormValidation';

import {getPathVariable} from '../../core/js/UrlUtils';
import { useSearchParams } from "react-router-dom";
import RadioForBoolean from '../../core/form/RadioForBoolean';
import MyDate from '../../core/components/MyDate';
import { useDispatch,useSelector } from 'react-redux';
import { updateMlmorderObj,addMlmorderObj, setShowEditForMlmorder} from 'store/slice/DmpSlice';
import { setApiInProgress } from 'store/slice/HeaderSlice';
import { setMessage } from 'store/slice/HeaderSlice';



export default function MlmorderEditForm(){
    const dispatch = useDispatch();
    const [formValues, setFormValues] = useState(getMlmorderStruct);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('Something went wrong');
    const [dataLoaded, setDataLoaded] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    
    const {mlmorderDashboard} = useSelector((state)=>state.dmpslice);
    const [mlmorderId, setMlmorderId] = useState(mlmorderDashboard.selectedId);
    const { businessid } = useSelector((state) => state.headerslice.userprofileInfo)
    

    const {apiInProgress} = useSelector((state)=>state.headerslice)
    useEffect(()=>{
    },[apiInProgress])

    useEffect(() => {
        if (mlmorderId!==-1) {
            if (dataLoaded) return;
            getAPI(mlmorderId, loadForm);
        }
        else {
           // formValues.<<CONTEXT>>.value=searchParams.get('<<CONTEXT>>');
            setDataLoaded(true);
        }

        setFormValues({
            ...formValues,
            ['businessid']: {
                ...formValues['businessid'],
                value: businessid
            }
        })
    },[]);

    const setNotification = (message) => {
        dispatch(setMessage(message));
    }
    const loadForm = (data)=>{
        setData(data, formValues, setFormValues);
        setDataLoaded(true);
    }
    const handleRadioChange = (name, value) => {
        setShowError(false);
        console.log(value+" == "+getRadioAPIvalue(value))
        updateValue(formValues, setFormValues, name, getRadioAPIvalue(value));
    }
    const getRadioValue = (value) => {
        if (value ) 
            return "yes"
        else 
            return "no"
    }
    const getRadioAPIvalue = (value) => {
        if (value ==="yes") 
            return true
        else 
            return false
    }
    const handleTextChange = (e) => {
        setShowError(false);
        const { name, value } = e.target;
        // Remove newlines for the description field
        const sanitizedValue = value.replace(/[\r\n]+/g, '')
        updateTextValue(formValues, setFormValues, { target: { name, value: sanitizedValue } });
    }
    const handleDoubleChange = (e) => {
        setShowError(false);
        const { name, value } = e.target;

        // Do not allow starting with '.'
        if (value.startsWith('.')) {
            return;
        }

        // Allow empty string so user can delete all characters
        if (value === '' || value === '.') {
            updateTextValue(formValues, setFormValues, { target: { name, value } });
            return;
        }

        // Regex: Allow up to 9 digits before decimal, optional decimal, up to 2 digits after decimal (Indian Rupees format)
        const regex = /^\d{0,9}(\.\d{0,2})?$/;

        if (regex.test(value)) {
            updateTextValue(formValues, setFormValues, { target: { name, value } });
        }
    }
    const handleNameChange = (e) =>{
        setShowError(false);
        
       if (validNameEntry(e))
        updateTextValue(formValues, setFormValues,e);
    }
    const handleMobileChange = (e) => {
        setShowError(false);
        
       if (validMobileNumberEntry(e))
            updateTextValue(formValues, setFormValues,e);
    }
    const handleEmailidChange = (e) => {
        setShowError(false);
        
       if (validEmailEntry(e))
            updateTextValue(formValues, setFormValues,e);
    }

    const createSuccessCallback = (obj) =>{
         dispatch(setApiInProgress(false));
        dispatch(addMlmorderObj(obj));
        setNotification('Record has been cretaed successfully !!!');
        dispatch(setShowEditForMlmorder(false));
    }
    const updateSuccessCallback = (obj) =>{
         dispatch(setApiInProgress(false));
        dispatch(updateMlmorderObj(obj));
        setNotification('Record with id['+mlmorderId+'] has been updated successfully !!!');
        dispatch(setShowEditForMlmorder(false));
        
    }
    const failuerCallback = (errorMsg) => {
         dispatch(setApiInProgress(false));
        setErrorMsg(errorMsg);
        setShowError(true);
    }
    const callCreateAPI = (formValues, successCallBack, failuerCallback) =>{
        dispatch(setApiInProgress(true));
        createAPI(formValues, successCallBack, failuerCallback);
    }
    const callUpdateAPI = (id,formValues, updateSuccessCallback, failuerCallback) =>{
        dispatch(setApiInProgress(true));
        updateAPI(id,formValues, updateSuccessCallback, failuerCallback);
    }
    const onSubmit=(e)=>{
        handleSubmit(e,mlmorderId, formValues, setFormValues, createSuccessCallback, updateSuccessCallback, failuerCallback, callCreateAPI, callUpdateAPI);
    }
    const setDate = (fieldName, value) => {
        var date = new Date(value);
        
        const day = date.getDate();
        const dayStr = day < 10 ? '0' + day : day.toString();

        const month = date.getMonth() + 1;
        const monthStr = month < 10 ? '0' + month : month.toString();
        var dateStr =date.getFullYear()+ "-" +  monthStr + "-" + dayStr + "T00:00:00.000Z";
        updateValue(formValues, setFormValues, fieldName, dateStr);
    }
    return (
        <form  noValidate onSubmit={onSubmit} >
            <Grid container direction="column" padding={.25}>
                {showError? <Alert severity="error">{errorMsg}</Alert>: ''}
                <Box sx={{ flexGrow: 1 }}>
                    <Grid item sx={{overflowY: "scroll", backgroundColor:'white',maxHeight:'58vh'}}>
                        <Grid container direction="column" padding={.25}>
                            <Grid item>
                                <Typography variant='h4'>{mlmorderId===-1?'Add':'Edit'} Referral Order </Typography>
                                <Divider/>
                            </Grid>
                            <Grid height='25px' ></Grid>
                            {dataLoaded?
                                <Grid container display="flex" spacing={2} direction="row" justifyContent="space-between" alignItems="center"> 
                                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.title.placeholder}
                                    required={formValues.title.required}
                                    label={formValues.title.label}
                                    name={formValues.title.name}
                                    value={formValues.title.value}
                                    onChange={handleTextChange}
                                    error={formValues.title.error}
                                    helperText={formValues.title.error && formValues.title.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.orderid.placeholder}
                                    required={formValues.orderid.required}
                                    label={formValues.orderid.label}
                                    name={formValues.orderid.name}
                                    value={formValues.orderid.value}
                                    onChange={handleTextChange}
                                    error={formValues.orderid.error}
                                    helperText={formValues.orderid.error && formValues.orderid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.ordervalue.placeholder}
                                    required={formValues.ordervalue.required}
                                    label={formValues.ordervalue.label}
                                    name={formValues.ordervalue.name}
                                    value={formValues.ordervalue.value}
                                    onChange={handleDoubleChange}
                                    error={formValues.ordervalue.error}
                                    helperText={formValues.ordervalue.error && formValues.ordervalue.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.partnerid.placeholder}
                                    required={formValues.partnerid.required}
                                    label={formValues.partnerid.label}
                                    name={formValues.partnerid.name}
                                    value={formValues.partnerid.value}
                                    onChange={handleTextChange}
                                    error={formValues.partnerid.error}
                                    helperText={formValues.partnerid.error && formValues.partnerid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.memberid.placeholder}
                                    required={formValues.memberid.required}
                                    label={formValues.memberid.label}
                                    name={formValues.memberid.name}
                                    value={formValues.memberid.value}
                                    onChange={handleTextChange}
                                    error={formValues.memberid.error}
                                    helperText={formValues.memberid.error && formValues.memberid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                    <Grid item lg={3} xs={12}>
    <MyDate 
                            label={formValues.orderdate.label}
                            fieldName={formValues.orderdate.name}
                            defaultValue={formValues.orderdate.value}
                            errStr={formValues.orderdate.errorMessage}
                            setDate={setDate} 
    />
</Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.creditvalue.placeholder}
                                    required={formValues.creditvalue.required}
                                    label={formValues.creditvalue.label}
                                    name={formValues.creditvalue.name}
                                    value={formValues.creditvalue.value}
                                    onChange={handleDoubleChange}
                                    error={formValues.creditvalue.error}
                                    helperText={formValues.creditvalue.error && formValues.creditvalue.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.addressid.placeholder}
                                    required={formValues.addressid.required}
                                    label={formValues.addressid.label}
                                    name={formValues.addressid.name}
                                    value={formValues.addressid.value}
                                    onChange={handleTextChange}
                                    error={formValues.addressid.error}
                                    helperText={formValues.addressid.error && formValues.addressid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.cartid.placeholder}
                                    required={formValues.cartid.required}
                                    label={formValues.cartid.label}
                                    name={formValues.cartid.name}
                                    value={formValues.cartid.value}
                                    onChange={handleTextChange}
                                    error={formValues.cartid.error}
                                    helperText={formValues.cartid.error && formValues.cartid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.deliverystatusid.placeholder}
                                    required={formValues.deliverystatusid.required}
                                    label={formValues.deliverystatusid.label}
                                    name={formValues.deliverystatusid.name}
                                    value={formValues.deliverystatusid.value}
                                    onChange={handleTextChange}
                                    error={formValues.deliverystatusid.error}
                                    helperText={formValues.deliverystatusid.error && formValues.deliverystatusid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.paymentid.placeholder}
                                    required={formValues.paymentid.required}
                                    label={formValues.paymentid.label}
                                    name={formValues.paymentid.name}
                                    value={formValues.paymentid.value}
                                    onChange={handleTextChange}
                                    error={formValues.paymentid.error}
                                    helperText={formValues.paymentid.error && formValues.paymentid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.originid.placeholder}
                                    required={formValues.originid.required}
                                    label={formValues.originid.label}
                                    name={formValues.originid.name}
                                    value={formValues.originid.value}
                                    onChange={handleTextChange}
                                    error={formValues.originid.error}
                                    helperText={formValues.originid.error && formValues.originid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.paymentorderid.placeholder}
                                    required={formValues.paymentorderid.required}
                                    label={formValues.paymentorderid.label}
                                    name={formValues.paymentorderid.name}
                                    value={formValues.paymentorderid.value}
                                    onChange={handleTextChange}
                                    error={formValues.paymentorderid.error}
                                    helperText={formValues.paymentorderid.error && formValues.paymentorderid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                    <Grid item lg={3} xs={12}>
    <MyDate 
                            label={formValues.dispatchedon.label}
                            fieldName={formValues.dispatchedon.name}
                            defaultValue={formValues.dispatchedon.value}
                            errStr={formValues.dispatchedon.errorMessage}
                            setDate={setDate} 
    />
</Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.remarks.placeholder}
                                    required={formValues.remarks.required}
                                    label={formValues.remarks.label}
                                    name={formValues.remarks.name}
                                    value={formValues.remarks.value}
                                    onChange={handleTextChange}
                                    error={formValues.remarks.error}
                                    helperText={formValues.remarks.error && formValues.remarks.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                        
                                    <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                        <TextField size="Normal"
                                            placeholder={formValues.businessid.placeholder}
                                            required={formValues.businessid.required}
                                            label={formValues.businessid.label}
                                            name={formValues.businessid.name}
                                            value={formValues.businessid.value}
                                            onChange={handleTextChange}
                                            error={formValues.businessid.error}
                                            helpertext={formValues.businessid.error && formValues.businessid.errorMessage}
                                            sx={{ width: '100%',  }}
                                        />
                                    </Grid> 
                                </Grid>
                            :<></>}
                        </Grid>
                    </Grid>
                </Box>
                <Grid height='25px' ></Grid>
                <Grid padding={1}>
                    <Divider/>
                </Grid>
                <Grid container direction="row" justifyContent="flex-end"  >
                {   apiInProgress?<CircularProgress/>:
                    <>
                        <Button variant="outlined" type="submit" >{mlmorderId===-1?'Add':'Save'}</Button>&nbsp;&nbsp;&nbsp;
                        <Button variant="outlined" onClick={()=>{dispatch(setShowEditForMlmorder(false));}}>Close</Button>
                    </>
                }
                </Grid>
            </Grid>
        </form>
    );
};